// passing the path into variables

const banner1 = '/assets/losnavegadores/home/bannerhome.webp';
// const banner2 = '/assets/losnavegadores/home/banner2.webp';
// const banner3 = '/assets/losnavegadores/home/banner.webp';

const destination1 = '/assets/losnavegadores/destinos/one.webp';
const destination2 =
	'/assets/losnavegadores/destinos/two.webp';
const destination3 = '/assets/losnavegadores/destinos/three.webp';
const destination4 =
	'/assets/losnavegadores/destinos/four.webp';
const destination5 = '/assets/losnavegadores/destinos/five.webp';
const destination6 =
	'/assets/losnavegadores/destinos/six.webp';
const banner = [banner1];

const destination = [destination1, destination2, destination3, destination4, destination5, destination6];

// const gallery = [gallery1, gallery2, gallery3, gallery4, gallery5, gallery6];

const navegdoresSlides = {
	banner,
	destination,
	// gallery
};

export default navegdoresSlides;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/navegadoresSlides.js